module.exports = __webpack_public_path__ + "img/qr-code.526bdc0d.webp";